import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

// User's uploaded photos
const GALLERY_IMAGES = [
  "https://customer-assets.emergentagent.com/job_music-doc-staging/artifacts/vuxyt7pm_Screenshot%202025-02-04%20at%2017.42.23.jpg",
  "https://customer-assets.emergentagent.com/job_music-doc-staging/artifacts/43unzb43_Screenshot%202025-02-04%20at%2017.41.25.jpg",
];

// Cinematic text content
const CINEMATIC_TEXT = [
  {
    overline: "The Story Must Be Told",
    text: <>Led by engineer Maurice <em className="italic">Pirahnahead</em> Herd and a team of industry veterans, it's time the story of United Sound is told.</>,
  },
];

// Standardized text height for all screens
const TEXT_HEIGHT = "min-h-[200px] md:min-h-[250px]";

const TextInterstitial = ({ overline, text, index }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start 0.9", "end 0.1"],
  });

  const opacity = useTransform(scrollYProgress, [0, 0.2, 0.8, 1], [0, 1, 1, 0]);

  return (
    <motion.div
      ref={ref}
      className={`${TEXT_HEIGHT} flex items-center justify-center px-6 sm:px-12 md:px-24 py-8`}
      style={{ opacity }}
      data-testid={`text-interstitial-${index}`}
    >
      <div className="w-full max-w-3xl text-center">
        <span className="font-mono text-[10px] sm:text-xs tracking-[0.2em] text-[#888888] uppercase block mb-4 sm:mb-6">
          {overline}
        </span>
        <p className="font-heading text-xl sm:text-2xl md:text-3xl lg:text-4xl font-light tracking-tight leading-relaxed text-[#F5F5F0]">
          {text}
        </p>
      </div>
    </motion.div>
  );
};

const ImageSection = ({ src, index, objectPosition = "center 30%" }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });

  const opacity = useTransform(scrollYProgress, [0.1, 0.3, 0.7, 0.9], [0, 1, 1, 0]);
  const scale = useTransform(scrollYProgress, [0.1, 0.3, 0.7, 0.9], [0.95, 1, 1, 0.98]);

  return (
    <motion.div
      ref={ref}
      className="min-h-[60vh] md:min-h-[80vh] flex items-center justify-center px-0"
      style={{ opacity, scale }}
      data-testid={`gallery-image-${index}`}
    >
      <div className="film-frame w-full">
        <img
          src={src}
          alt={`Documentary scene ${index + 1}`}
          className="gallery-image rounded-sm shadow-2xl"
          style={{ objectPosition }}
          loading="lazy"
        />
      </div>
    </motion.div>
  );
};

const GallerySection = () => {
  return (
    <section className="gallery-section" data-testid="gallery-section">
      {/* First image - two men */}
      <ImageSection src={GALLERY_IMAGES[0]} index={0} />
      
      {/* The Story Must Be Told */}
      <TextInterstitial
        overline={CINEMATIC_TEXT[0].overline}
        text={CINEMATIC_TEXT[0].text}
        index={0}
      />
      
      {/* Last image - fist in air */}
      <ImageSection src={GALLERY_IMAGES[1]} index={1} objectPosition="center 0%" />
    </section>
  );
};

export default GallerySection;
